import { Component, Input, OnInit } from '@angular/core';
import { IProccess } from 'src/app/interfaces/proccess.interface';

@Component({
  selector: 'archiving-info',
  templateUrl: './archiving-info.component.html'
})
export class ArchivingInfoComponent implements OnInit {

  @Input() process: IProccess

  constructor() { }

  ngOnInit(): void {
  }

}
